import Trc20Icon from "@/icons/withdraw/trc20Icon";
import EthereumIcon from "@/icons/withdraw/coins/ethereumIcon";
import USDTIcon from "@/icons/withdraw/coins/usdtIcon";
import BinanceIcon from "@/icons/withdraw/coins/binanceIcon";
import { sharkCoin } from "@/constants";
import SharkCoinIcon from "@/icons/withdraw/coins/sharkCoinIcon";

// import USDDIcon from "@/icons/withdraw/coins/usddIcon";
// import USDJIcon from "@/icons/withdraw/coins/usdjIcon";
// import TronIcon from "@/icons/withdraw/coins/tronIcon";
// import JustIcon from "@/icons/withdraw/coins/justIcon";
// import KleverIcon from "@/icons/withdraw/coins/kleverIcon";
// import BitTorrentIcon from "@/icons/withdraw/coins/bitTorrentIcon";
// import MineralIcon from "@/icons/withdraw/coins/mineralIcon";
// import WINKLinkIcon from "@/icons/withdraw/coins/winkLinkIcon";
// import SunIcon from "@/icons/withdraw/coins/sunIcon";
// import TronBetLIVEIcon from "@/icons/withdraw/coins/tronBetLiveIcon";
// import WrappedBTCIcon from "@/icons/withdraw/coins/wrappedBTCIcon";
// import WrappedETHIcon from "@/icons/withdraw/coins/wrappedETHIcon";
// import WrappedSOLIcon from "@/icons/withdraw/coins/wrappedSOLIcon";
// import WrappedBinanceIcon from "@/icons/withdraw/coins/wrappedBinanceIcon";
// import BinanceUSDIcon from "@/icons/withdraw/coins/binanceUsdIcon";
// import PancakeSwapTokenIcon from "@/icons/withdraw/coins/pancakeSwapIcon";
// import VenusIcon from "@/icons/withdraw/coins/venusIcon";
// import AutofarmIcon from "@/icons/withdraw/coins/autofarmIcon";
// import BakeryTokenIcon from "@/icons/withdraw/coins/bakeryTokenIcon";
// import VenusRewardIcon from "@/icons/withdraw/coins/venusRewardIcon";
// import SpartanProtocolIcon from "@/icons/withdraw/coins/spTokenIcon";
// import BeefyFinanceIcon from "@/icons/withdraw/coins/beefyFinanceIcon";
// import TrueUSDIcon from "@/icons/withdraw/coins/trueUsdIcon";
// import ChainLinkIcon from "@/icons/withdraw/coins/chainLinkIcon";
// import { ShibaIcon } from "@/icons/withdraw/coins/shibaIcon";
// import UniswapIcon from "@/icons/withdraw/coins/uniswap";
// import DaiIcon from "@/icons/withdraw/coins/daiIcon";
// import PaxosStandardIcon from "@/icons/withdraw/coins/paxosIcon";
// import GeminiIcon from "@/icons/withdraw/coins/geminiIcon";
// import BitCoinIcon from "@/icons/withdraw/coins/bitCoinIcon";
// import SolanaIcon from "@/icons/withdraw/coins/solanaIcon";
// import SynthetixIcon from "@/icons/withdraw/coins/synthetixIcon";

export type TokenData = {
  label: string;
  value: string;
  currencyType?: string;
  Icon?: React.ElementType;
};

export type NetworksData = {
  label: string;
  value: string;
  Icon?: React.ElementType;
};

export const networksByTokens: { [key: string]: NetworksData[] } = {
  Tether: [
    // {
    //   label: "ERC20",
    //   value: "ERC20",
    //   Icon: Trc20Icon,
    // },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  FFT: [
    // {
    //   label: "ERC20",
    //   value: "ERC20",
    //   Icon: Trc20Icon,
    // },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  USDCoin: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
    // {
    //   label: "Solana",
    //   value: "Solana",
    //   Icon: Trc20Icon,
    // },
  ],
  USDD: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  USDJ: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  Tron: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  Just: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  Klever: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  BitTorrentUSD: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  Mineral: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  WINKLink: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  SUN: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  TronBetLIVE: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
  ],
  WrappedBTC: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  WrappedETH: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  WrappedSOL: [
    {
      label: "TRC20",
      value: "TRC20",
      Icon: Trc20Icon,
    },
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  TrueUSD: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  Ethereum: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
    // {
    //   label: "BEP20",
    //   value: "BEP20",
    //   Icon: Trc20Icon,
    // },
  ],
  Chainlink: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  ShibaInu: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  Uniswap: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  Dai: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  PaxosStandard: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  GeminiUSD: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  SynthetixUSD: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
  Binance: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
    // {
    //   label: "ERC20",
    //   value: "ERC20",
    //   Icon: Trc20Icon,
    // },
  ],
  WrappedBinanceCoin: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  BinanceUSD: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  PancakeSwapToken: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  Venus: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  Autofarm: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  BakeryToken: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  VenusRewardToken: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  SpartanProtocolToken: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  BeefyFinance: [
    {
      label: "BEP20",
      value: "BEP20",
      Icon: Trc20Icon,
    },
  ],
  Bitcoin: [
    {
      label: "Bitcoin",
      value: "Bitcoin",
      Icon: Trc20Icon,
    },
  ],
  Solana: [
    {
      label: "Solana",
      value: "Solana",
      Icon: Trc20Icon,
    },
  ],
  Shrl: [
    {
      label: "ERC20",
      value: "ERC20",
      Icon: Trc20Icon,
    },
  ],
};

export const tokens: TokenData[] = [
  {
    label: "Tether",
    value: "Tether",
    currencyType: "USDT",
    Icon: USDTIcon,
  },
  {
    label: "Fireflies Token",
    value: "FFT",
    currencyType: "FFT",
    Icon: () => (
      <img
        className="h-[18px]"
        src="https://s3-casineo-prod.s3.eu-west-1.amazonaws.com/assets/fft.svg"
        alt="FFT"
      />
    ),
  },
  // {
  //   label: "Shrl",
  //   value: "Shrl",
  //   currencyType: "SHRL",
  //   Icon: SharkCoinIcon,
  // },
  // {
  //   label: "USD Coin",
  //   value: "USDCoin",
  //   currencyType: "USDC",
  //   Icon: UsdCoinIcon,
  // },
  // {
  //   label: "USDD",
  //   value: "USDD",
  //   currencyType: "USDD",
  //   Icon: USDDIcon,
  // },
  // {
  //   label: "USDJ",
  //   value: "USDJ",
  //   currencyType: "USDJ",
  //   Icon: USDJIcon,
  // },
  // {
  //   label: "Tron",
  //   value: "Tron",
  //   currencyType: "TRX",
  //   Icon: TronIcon,
  // },
  // {
  //   label: "Just",
  //   value: "Just",
  //   currencyType: "JST",
  //   Icon: JustIcon,
  // },
  // {
  //   label: "Klever",
  //   value: "Klever",
  //   currencyType: "KLV",
  //   Icon: KleverIcon,
  // },
  // {
  //   label: "BitTorrent USD",
  //   value: "BitTorrentUSD",
  //   currencyType: "BUSD",
  //   Icon: BitTorrentIcon,
  // },
  // {
  //   label: "Mineral",
  //   value: "Mineral",
  //   currencyType: "MNR",
  //   Icon: MineralIcon,
  // },
  // {
  //   label: "WINKLink",
  //   value: "WINKLink",
  //   currencyType: "WIN",
  //   Icon: WINKLinkIcon,
  // },
  // {
  //   label: "SUN",
  //   value: "SUN",
  //   currencyType: "SUN",
  //   Icon: SunIcon,
  // },
  // {
  //   label: "TronBetLIVE",
  //   value: "TronBetLIVE",
  //   currencyType: "LIVE",
  //   Icon: TronBetLIVEIcon,
  // },
  // {
  //   label: "Wrapped BTC",
  //   value: "WrappedBTC",
  //   currencyType: "WBTC",
  //   Icon: WrappedBTCIcon,
  // },
  // {
  //   label: "WrappedETH",
  //   value: "WrappedETH",
  //   currencyType: "WETH",
  //   Icon: WrappedETHIcon,
  // },
  // {
  //   label: "WrappedSOL",
  //   value: "WrappedSOL",
  //   currencyType: "XSOL",
  //   Icon: WrappedSOLIcon,
  // },
  // {
  //   label: "True USD",
  //   value: "TrueUSD",
  //   currencyType: "TUSD",
  //   Icon: TrueUSDIcon,
  // },
  // {
  //   label: "Ethereum",
  //   value: "Ethereum",
  //   currencyType: "ETH",
  //   Icon: EthereumIcon,
  // },
  // {
  //   label: "Chainlink",
  //   value: "Chainlink",
  //   currencyType: "LINK",
  //   Icon: ChainLinkIcon,
  // },
  // {
  //   label: "Shiba Inu",
  //   value: "ShibaInu",
  //   currencyType: "SHIB",
  //   Icon: ShibaIcon,
  // },
  // {
  //   label: "Uniswap",
  //   value: "Uniswap",
  //   currencyType: "UNI",
  //   Icon: UniswapIcon,
  // },
  // {
  //   label: "Dai",
  //   value: "Dai",
  //   currencyType: "DAI",
  //   Icon: DaiIcon,
  // },
  // {
  //   label: "Paxos Standard",
  //   value: "PaxosStandard",
  //   currencyType: "PAX",
  //   Icon: PaxosStandardIcon,
  // },
  // {
  //   label: "Gemini USD",
  //   value: "GeminiUSD",
  //   currencyType: "GUSD",
  //   Icon: GeminiIcon,
  // },
  // {
  //   label: "Synthetix USD",
  //   value: "SynthetixUSD",
  //   currencyType: "SUSD",
  //   Icon: SynthetixIcon,
  // },
  {
    label: "Binance",
    value: "Binance",
    currencyType: "BNB",
    Icon: BinanceIcon,
  },
  // {
  //   label: "Wrapped Binance Coin",
  //   value: "WrappedBinanceCoin",
  //   currencyType: "WBNB",
  //   Icon: WrappedBinanceIcon,
  // },
  // {
  //   label: "Binance USD",
  //   value: "BinanceUSD",
  //   currencyType: "BUSD",
  //   Icon: BinanceUSDIcon,
  // },
  // {
  //   label: "Pancake Swap Token",
  //   value: "PancakeSwapToken",
  //   currencyType: "CAKE",
  //   Icon: PancakeSwapTokenIcon,
  // },
  // {
  //   label: "Venus",
  //   value: "Venus",
  //   currencyType: "XVS",
  //   Icon: VenusIcon,
  // },
  // {
  //   label: "Autofarm",
  //   value: "Autofarm",
  //   currencyType: "AUTO",
  //   Icon: AutofarmIcon,
  // },
  // {
  //   label: "BakeryToken",
  //   value: "BakeryToken",
  //   currencyType: "BAKE",
  //   Icon: BakeryTokenIcon,
  // },
  // {
  //   label: "Venus Reward Token",
  //   value: "VenusRewardToken",
  //   currencyType: "VRT",
  //   Icon: VenusRewardIcon,
  // },
  // {
  //   label: "Spartan Protocol Token",
  //   value: "SpartanProtocolToken",
  //   currencyType: "SPARTAN",
  //   Icon: SpartanProtocolIcon,
  // },
  // {
  //   label: "Beefy Finance",
  //   value: "BeefyFinance",
  //   currencyType: "BIFI",
  //   Icon: BeefyFinanceIcon,
  // },
  // {
  //   label: "Bitcoin",
  //   value: "Bitcoin",
  //   currencyType: "BTC",
  //   Icon: BitCoinIcon,
  // },
  // {
  //   label: "Solana",
  //   value: "Solana",
  //   currencyType: "SOL",
  //   Icon: SolanaIcon,
  // },
];
